__turbopack_context__.v({
  "badge": "TagsInput-module-scss-module__LOvajq__badge",
  "createOption": "TagsInput-module-scss-module__LOvajq__createOption",
  "dropdown": "TagsInput-module-scss-module__LOvajq__dropdown",
  "inner": "TagsInput-module-scss-module__LOvajq__inner",
});
